import { useEffect, useState } from "react";
import "./PreviewBanner.css";

// Preview mode only on preview hosts (workers.dev, localhost). The real domain
// is always live. Adding ?live to a preview URL hides the banner and every
// amber [data-ph] placeholder marker (how the launched site will look).
const PREVIEW_HOST = /(\.workers\.dev|^localhost|^127\.0\.0\.1)$/;

export default function PreviewBanner() {
  const [live, setLive] = useState(true);

  useEffect(() => {
    const isLive =
      !PREVIEW_HOST.test(window.location.hostname) ||
      new URLSearchParams(window.location.search).has("live");
    document.documentElement.classList.toggle("live", isLive);
    setLive(isLive);
  }, []);

  if (live) return null;

  return (
    <div className="preview-banner" role="status">
      ⚠ PREVIEW — items outlined in amber are placeholders awaiting confirmation.
      Add <code>?live</code> to the address to see the clean launch version.
    </div>
  );
}
